export default {"src":"/_next/static/media/qtum.12e19466.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};